import { BsXCircle } from '@react-icons/all-files/bs/BsXCircle';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Modal as BootstrapModal, ModalHeader } from 'reactstrap';
import { bind } from '../Utils/Bind';
import { Deferred } from '../Utils/Deferred';
import { componentAutoReaction } from '../Utils/MobxTools';
import { UserAgent } from '../Utils/UserAgent';

export class SnapshotPopoutHandle {
    @bind
    @action
    public open() {
        this.isShowing = true;
        this.deferred = new Deferred<boolean>();
    }

    @bind
    @action
    public close() {
        if (!this.deferred) throw new Error('Popout must be open first');

        this.isShowing = false;

        this.opened = false;

        this.deferred.resolve(true);
    }

    @bind
    @action
    public reject() {
        if (!this.deferred) throw new Error('Popout must be open first');

        this.isShowing = false;
        this.deferred.resolve(false);
    }

    @bind
    @action
    public resolve() {
        if (!this.deferred) throw new Error('Popout must be open first');

        this.isShowing = false;
        this.deferred.resolve(true);
    }

    @observable
    public isShowing: boolean = false;

    @observable
    public opened: boolean = false;

    @observable
    public deferred: Deferred<boolean> | undefined;

    @observable
    public popoutRef?: HTMLDivElement;
}

export interface ISnapshotPopoutProps {
    onOpened?(): void;
    onClosed?(): void;
    bodyRef?(r: HTMLDivElement | null): HTMLDivElement | null;
    readonly popoutHandle: SnapshotPopoutHandle;
    readonly snapshotUri: string;
    readonly size: 'full' | 'side';
    readonly landscape?: boolean;
    readonly popVu?: boolean;
}

@observer
export class SnapshotPopout extends React.Component<ISnapshotPopoutProps> {
    public componentDidMount() {
        componentAutoReaction(this, () => this.props.popoutHandle.isShowing, this.onHandleToggle);
    }

    public render() {
        const { popoutHandle, size, snapshotUri, landscape, popVu } = this.props;
        return (
            <div className={`popout ${popoutHandle.isShowing ? 'show' : 'hide'} ${size}`} ref={this.setRef}>
                <div className="d-flex h-100 flex-column">
                    <div className="row w-100">
                        <div className="col-12 d-flex">
                            {!popVu && <div className="f-26 d-inline-block">InfiniteTouch®</div>}
                            {popVu && <div className="f-26 d-inline-block">PopVu™</div>}
                            <a className="ms-auto btn btn-link-white" onClick={this.onClose}>
                                <BsXCircle />
                            </a>
                        </div>
                    </div>

                    <div className="row flex-grow-1">
                        <div className="col-12 text-center p-5">
                            <img
                                alt="Image not found. Try a Refresh"
                                src={snapshotUri}
                                className={landscape ? 'img-fluid w-100' : 'img-fluid h-100'}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    @bind
    @action
    private setRef(ref: HTMLDivElement) {
        this.props.popoutHandle.popoutRef = ref;
    }

    @bind
    private onClose() {
        this.props.popoutHandle.close();
    }

    @bind
    private onHandleToggle(showing: boolean) {
        if (showing) this.onHandleOpened();
        else this.onHandleClosed();
    }

    @bind
    private onHandleOpened() {
        if (this.props.onOpened) this.props.onOpened();
    }

    @bind
    private onHandleClosed() {
        if (this.props.onClosed) this.props.onClosed();
    }
}
